import { api } from '@services';

import Equipment, {
  IEquipmentApiModel,
  IEquipmentWithoutProduct,
} from '@models/Equipment.model';

const getEquipment = async (id: string): Promise<IEquipmentWithoutProduct> => {
  const { data: equipment } = await api.get<IEquipmentApiModel>(
    `/equipments/${id}`,
  );

  if (equipment.product) return Equipment.fromApiModel(equipment);
  return Equipment.fromApiModelWithoutProduct(equipment);
};

export { getEquipment };
